module.exports = __webpack_public_path__ + "static/media/cabin.6d5f1aa5.jpg";